import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// 🔐 Firebase Config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// 🚀 Initialize App
const app = initializeApp(firebaseConfig);

// ===============================
// 🧠 FIRESTORE DATABASES
// ===============================

// Main database
export const usersDB = getFirestore(app, "users");

// 🔥 Your separate databases
export const businessDB = getFirestore(app, "business");
export const businessBackupDB = getFirestore(app, "business-backup");

export const organizationDB = getFirestore(app, "organization");
export const organizationBackupDB = getFirestore(app, "organization-backup");

export const personalDB = getFirestore(app, "personal");

// ===============================
// 🔐 AUTH & STORAGE
// ===============================

export const auth = getAuth(app);
export const storage = getStorage(app);

// ===============================
export default app;